export default {
    getAll(dto) {
        let data = {
            SchoolYear: dto.SchoolYear || '',
            SponsorID: dto.SponsorID || -1,
            IntermediaryID: dto.IntermediaryID || -1,
            InstitutionID: dto.InstitutionID || -1,
            StatusType: dto.StatusType || '',
            PageNumber: dto.PageNumber || 1,
            PageRows: dto.PageRows || 100,
            SortByColumn: dto.SortByColumn || ',',
            SortDirection: dto.SortDirection || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/SurveyAdmin/GetAll',
            data: data,
        });
    },
    getByID(id) {
        let params = { SurveyID: id || -1 };

        return DMUtils.http({
            method: 'GET',
            url: '/SurveyAdmin/GetByID',
            params: params,
        });
    },
    getDetailsByID(id) {
        let params = { SurveyID: id || -1 };

        return DMUtils.http({
            method: 'GET',
            url: '/SurveyAdmin/GetDetailsByID',
            params: params,
        });
    },
    create(dto) {
        let data = {
            InstitutionID: dto.InstitutionID || -1,
            StartDate: dto.StartDate || '',
            EndDate: dto.EndDate || '',
            TransformationTeamEnabled: dto.TransformationTeamEnabled || false,
            StudentSuccessCommunityEnabled: dto.StudentSuccessCommunityEnabled || false
        }

        return DMUtils.http({
            method: 'POST',
            url: '/SurveyAdmin/Create',
            data: data,
        });
    },
    update(dto) {
        let data = {
            SurveyID: dto.SurveyID || -1,
            InstitutionID: dto.InstitutionID || -1,
            StartDate: dto.StartDate || '',
            EndDate: dto.EndDate || '',
            TransformationTeamEnabled: dto.TransformationTeamEnabled || false,
            StudentSuccessCommunityEnabled: dto.StudentSuccessCommunityEnabled || false,
            RowVersion: dto.RowVersion || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/SurveyAdmin/Update',
            data: data,
        });
    },
    getScheduledReminders(id) {
        let params = {
            SurveyID: id
        }

        return DMUtils.http({
            method: 'GET',
            url: '/SurveyAdmin/GetScheduledReminders',
            params: params
        });
    },
    getScheduledReminderByID(id) {
        let params = {
            SurveyScheduledReminderID: id
        }

        return DMUtils.http({
            method: 'GET',
            url: '/SurveyAdmin/GetScheduledReminderByID',
            params: params
        });
    },
    createScheduledReminder(dto) {
        let data = {
            SurveyID: dto.SurveyID || -1,
            ReminderSendDateTime: dto.ReminderSendDateTime || '',
            ReminderEmailText: dto.ReminderEmailText || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/SurveyAdmin/CreateScheduledReminder',
            data: data
        });
    },
    updateScheduledReminder(dto) {
        let data = {
            SurveyScheduledReminderID: dto.SurveyScheduledReminderID || -1,
            ReminderSendDateTime: dto.ReminderSendDateTime || '',
            ReminderEmailText: dto.ReminderEmailText || '',
            RowVersion: dto.RowVersion || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/SurveyAdmin/UpdateScheduledReminder',
            data: data
        });
    },
    deleteScheduledReminder(id) {
        let data = {
            SurveyScheduledReminderID: id
        }

        return DMUtils.http({
            method: 'POST',
            url: '/SurveyAdmin/DeleteScheduledReminder',
            data: data
        });
    },
    getSchoolYears() {
        return DMUtils.http({
            method: 'GET',
            url: '/SurveyAdmin/GetSchoolYears',
        });
    },
    getSurveyStatuses() {
        return DMUtils.http({
            method: 'GET',
            url: '/SurveyAdmin/GetSurveyStatuses',
        });
    },
    getAllTeams(id) {
        let params = { SurveyID: id || -1 };

        return DMUtils.http({
            method: 'GET',
            url: '/Team/GetAll',
            params: params
        });
    },
    getAllSurveyTeamUsers(dto) {
        let data = {
            SurveyID: dto.SurveyID || -1,
            TeamType: dto.TeamType ? dto.TeamType.TeamType : '',
            SearchText: dto.SearchText || '',
            IncludeInactive: dto.IncludeInactive || false,
            PageNumber: dto.PageNumber || 1,
            PageRows: dto.PageRows || 100,
            SortByColumn: dto.SortByColumn || '',
            SortDirection: dto.SortDirection || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Team/GetAllSurveyTeamUsers',
            data: data
        })
    },
    inviteTeamUser(dto) {
        let data = {
            SurveyID: dto.SurveyID || -1,
            TeamID: dto.TeamID || -1,
            EmailAddress: dto.EmailAddress || '',
            InvitationSendDateTime: dto.InvitationSendDateTime || ''
        }
        
        return DMUtils.http({
            method: 'POST',
            url: '/Team/InviteTeamUser',
            data: data
        });
    },
    importTeamUsers(dto) {
        let data = {
            SurveyID: dto.SurveyID || -1,
            TeamID: dto.TeamID || -1,
            EmailAddressString: dto.EmailAddressString || '',
            InvitationSendDateTime: dto.InvitationSendDateTime || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Team/ImportTeamUsers',
            data: data
        });
    },
    deactivateUser(id) {
        let data = { RespondentID: id };

        return DMUtils.http({
            method: 'POST',
            url: '/Team/DeactivateTeamUser',
            data: data
        })
    },
    getTime() {
        return DMUtils.http({
            method: 'GET',
            url: '/Team/Ping',
        })
    },
    getCustomizationByID(id) {
        let params = {
            IntermediaryID: id
        }

        return DMUtils.http({
            method: 'GET',
            url: '/Intermediary/GetCustomizationByID',
            params: params
        });
    },
    updateCustomization(dto) {
        let data = {
            IntermediaryID: dto.IntermediaryID || -1,
            IntroParagraph: dto.IntroParagraph || '',
            LogoBase64: dto.LogoBase64 || '',
            ShowIntroParagraph: dto.ShowIntroParagraph || false,
            RowVersion: dto.RowVersion || ''
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Intermediary/UpdateCustomization',
            data: data
        });
    }
};
